import React from "react";
import GenericList from "./GenericList";

function RegimeCostList(props) {
    return (
        <GenericList label="Režijné náklady"
                     headers={['Názov', 'Počet', 'Cena', 'Akcie']}
                     mainColumnName="Nazov"
                     list={props.data.Rezijne_Naklady}
                     options={props.data.Rezijne_Naklady_options}
                     optionDisplay={'Nazov'}
                     select={props.select}
                     value={props.data.Rezijne_Naklady}
                     update={props.update}
                     delete={props.delete}
                     part={props.data.Rezijne_Naklady}
                     singleName="Rezijny_Naklad"
                     instanceName="Nazov"/>
    )
}

export default RegimeCostList
